import React, { useState } from 'react';
import { PRIVATE_MARKDOWN_HELP_VIEWER_PILLBOX } from './pillbox';
import { IHelpArticle, MarkdownHelpArticles } from './help-articles';
import { PRIVATE_MARKDOWN_HELP_VIEWER_VIEWPORT } from './viewport';

interface IMarkdownHelpViewerProps {
}

export const MarkdownHelpViewer: React.FunctionComponent<IMarkdownHelpViewerProps> = (props) => {
  const [activeArticle, setActiveArticle] = useState(MarkdownHelpArticles[0]);

  const onArticleChangeRequest = (article: IHelpArticle) => {
    setActiveArticle(article);
  };

  return (
    <div>
      <PRIVATE_MARKDOWN_HELP_VIEWER_PILLBOX
        activeArticle={activeArticle}
        onArticleChangeRequest={onArticleChangeRequest}
      />
      <PRIVATE_MARKDOWN_HELP_VIEWER_VIEWPORT article={activeArticle} />
    </div>
  );
};
